import emptyFolderWithoutConfirmation from '../actions/actionCreators/emptyFolderWithoutConfirmation';
import { emptyFolderService } from '../services/emptyFolderService';
import { listViewStore } from 'owa-mail-list-store';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import getItemidsFromMessages from 'owa-mail-list-store/lib/utils/getItemIdsFromMessages';
import { actionNames, EmptyFolderStoreUpdate } from 'owa-mail-store-actions';
import clearTableViewLastEmptiedTime from 'owa-mail-triage-action/lib/actions/clearTableViewLastEmptiedTime';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { orchestrator } from 'satcheljs';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';

orchestrator(emptyFolderWithoutConfirmation, actionMessage => {
    // Collect itemIds based on listViewType
    let itemIdsToExclude: string[] = [];
    if (actionMessage.rowKeysToExclude.length > 0) {
        const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);
        switch (tableView.tableQuery.listViewType) {
            case ReactListViewType.Conversation:
                itemIdsToExclude = getItemIdsFromConversations(
                    actionMessage.rowKeysToExclude,
                    actionMessage.tableViewId
                );
                break;
            case ReactListViewType.Message:
                itemIdsToExclude = getItemidsFromMessages(
                    actionMessage.rowKeysToExclude,
                    tableView
                );
                break;
        }
    }

    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);

    // TODO: VSO 11909: Handle undo for destructive mail actions
    const actionResponse = emptyFolderService(
        actionMessage.folder,
        actionMessage.disposalType,
        actionMessage.deleteSubFolders,
        actionMessage.clientLastSyncTime,
        itemIdsToExclude,
        actionMessage.shouldSupportBulkActions
    )
        .then(() => {
            tableView && clearTableViewLastEmptiedTime(tableView);
        })
        .catch(() => {
            tableView && clearTableViewLastEmptiedTime(tableView);
        });

    raiseAction<EmptyFolderStoreUpdate>(actionNames.EmptyFolderStoreUpdate)(
        actionMessage.folder,
        actionMessage.clientLastSyncTime,
        actionMessage.deletedItemsFolderId,
        actionMessage.rowKeysToExclude
    );

    return actionResponse;
});
